import { WORK_MODULES } from "@/modules/workModuleCore";

/** ¿Mostrar barra lateral operativa según preferencia global? */
export function resolveBuyerOperationalSidebar({
  buyerModuleSidebarEnabled = false,
  useModuleNav = false,
  isPlatformDesigner = false,
  activeWorkModule = WORK_MODULES.VISOR_SAT,
  isPanelHub = false,
} = {}) {
  if (!buyerModuleSidebarEnabled) return false;
  if (!useModuleNav) return false;
  // Diseñador en su módulo: la barra del diseñador se controla aparte (showDesignerModuleSidebar).
  if (isPlatformDesigner && !isPanelHub && activeWorkModule === WORK_MODULES.DISENADOR) {
    return false;
  }
  return true;
}

/** Módulo cuyo menú lateral mostrar en Panel General (evita menú Diseñador en /). */
export function resolvePanelHubSidebarWorkModule(activeWorkModule) {
  if (activeWorkModule === WORK_MODULES.DISENADOR) {
    return WORK_MODULES.VISOR_SAT;
  }
  return activeWorkModule || WORK_MODULES.VISOR_SAT;
}
